var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistancia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330 330",
    style: {
      enableBackground: "new 0 0 330 330"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_495_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_496_",
    x: 170,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_497_",
    x: 90,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_498_",
    x: 50,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_500_",
    x: 130,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_501_",
    x: 250,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_502_",
    x: 210,
    y: 259.609,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_503_",
    d: "M150,115.4c0-41.36-33.646-75.009-75.001-75.009C33.644,40.391,0,74.04,0,115.4 c0,67.33,64.064,109.981,66.792,111.764c2.493,1.629,5.35,2.444,8.207,2.444c2.857,0,5.714-0.815,8.207-2.444 c0.357-0.233,8.859-5.825,19.522-15.76C124.294,191.316,150,158.354,150,115.4z M82.28,189.454 c-2.652,2.471-5.13,4.608-7.294,6.386C60.051,183.593,30,154.133,30,115.4c0-24.818,20.186-45.009,44.999-45.009 C99.812,70.391,120,90.582,120,115.4C120,147.565,99.488,173.424,82.28,189.454z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_506_",
    cx: 75,
    cy: 115.391,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_507_",
    d: "M254.999,40.391C213.644,40.391,180,74.04,180,115.4c0,67.33,64.064,109.981,66.792,111.764 c2.493,1.629,5.35,2.444,8.207,2.444c2.857,0,5.714-0.815,8.207-2.444c0.357-0.233,8.859-5.825,19.523-15.76 C304.294,191.316,330,158.354,330,115.4C330,74.04,296.354,40.391,254.999,40.391z M262.28,189.454 c-2.652,2.471-5.13,4.608-7.294,6.386C240.051,183.593,210,154.133,210,115.4c0-24.818,20.186-45.009,44.999-45.009 C279.813,70.391,300,90.582,300,115.4C300,147.565,279.488,173.424,262.28,189.454z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_510_",
    cx: 255,
    cy: 115.391,
    r: 20
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistancia);
export default __webpack_public_path__ + "static/media/distancia.15be8325a1ca547461e7f5346512c33c.svg";
export { ForwardRef as ReactComponent };